import React, { lazy, Suspense, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import LoadingIndicator from './LoadingIndicator';
import AppAppBar from '../AppBar/AppAppBar';
import AppFooter from '../AppBar/AppFooter';

// Lazy load components
const Home = lazy(() => import('../Home/Home'));
const AboutUs = lazy(() => import('../Faq/AboutUs'));
const ContactUs = lazy(() => import('../Faq/ContactUs'));
const Adsl = lazy(() => import('../Internet/Adsl'));
const Vdsl = lazy(() => import('../Internet/Vdsl'));
const CorporateDsl = lazy(() => import('../Internet/CorporateDsl'));
const Microwave = lazy(() => import('../Internet/Microwave'));
const Broadband = lazy(() => import('../Internet/Broadband/Broadband'));
const SamaFlix = lazy(() => import('../Internet/SamaFlix'));
const Answers = lazy(() => import('../Faq/Answers'));
const FairUsePolicy = lazy(() => import('../Internet/Broadband/FairUsePolicy'));
const Vpn = lazy(() => import('../Services/Vpn'));
const DomainRegister = lazy(() => import('../Services/DomainRegister'));
const Voip = lazy(() => import('../Services/Voip'));
const NetworkSolutions = lazy(() => import('../Services/NetworkSolutions'));
const ContentDeliveryNetworks = lazy(() => import('../Services/ContentDeliveryNetworks'));
const TechnicalSupport = lazy(() => import('../Services/TechnicalSupport'));
const NetworkInfrastructureService = lazy(() => import('../Services/NetworkInfrastructureService'));
const CloudComputingService = lazy(() => import('../Services/CloudComputingService'));
const WebHosting = lazy(() => import('../Services/WebHosting'));
const NotFound = lazy(() => import('./NotFound'));

function AppRoutes() {
    const validRoutes = [
        'aboutus', 'contactus', 'vpn', 'webhosting', 'domainregister', 'voip',
        'networksolutions', 'contentdeliverynetwork', 'technicalsupport', 'networkinfrastructureservices',
        'cloudcomputingservices', 'fairusepolicy', 'answers', 'adsl', 'vdsl', 'broadband',
        'microwave', 'corporatedsl', 'samaflix'
    ];

    const [currentRoute, setCurrentRoute] = useState(
        window.location.pathname.substring(1) || 'home'
    );

    useEffect(() => {
        window.history.pushState(null, '', `/${currentRoute}`);
    }, [currentRoute]);

    const navigate = (route) => {
        setCurrentRoute(route);
    };

    const renderComponent = () => {
        if (!validRoutes.includes(currentRoute) && currentRoute !== 'home') {
            return <NotFound navigate={navigate} />;
        }

        switch (currentRoute) {
            case 'aboutus': return <AboutUs />;
            case 'contactus': return <ContactUs />;
            case 'vpn': return <Vpn />;
            case 'webhosting': return <WebHosting />;
            case 'domainregister': return <DomainRegister />;
            case 'voip': return <Voip />;
            case 'networksolutions': return <NetworkSolutions />;
            case 'contentdeliverynetwork': return <ContentDeliveryNetworks />;
            case 'technicalsupport': return <TechnicalSupport />;
            case 'networkinfrastructureservices': return <NetworkInfrastructureService />;
            case 'cloudcomputingservices': return <CloudComputingService />;
            case 'fairusepolicy': return <FairUsePolicy />;
            case 'answers': return <Answers />;
            case 'adsl': return <Adsl />;
            case 'vdsl': return <Vdsl />;
            case 'broadband': return <Broadband />;
            case 'microwave': return <Microwave />;
            case 'corporatedsl': return <CorporateDsl />;
            case 'samaflix': return <SamaFlix />;
            default: return <Home />;
        }
    };

    return (
        <>
            <Helmet>
                <title>Data Plus S.A.R.L</title>
            </Helmet>
            <AppAppBar navigate={navigate} />
            <Suspense fallback={<LoadingIndicator />}>
                {renderComponent()}
            </Suspense>
            <AppFooter />
        </>
    );
}

export default AppRoutes;
